import styles from './SummerLandingPage.module.css';
import { SiteLayout } from '@features/shared/ui/SiteLayout';
import { SiteLogoWidget } from '@features/shared/ui/SiteLogo/SiteLogoWidget';
import { UserSettingsMenuWidget } from '@features/user/ui/UserSettingsMenu/UserSettingsMenuWidget';
import { UserAuthMenuWidget } from '@features/user/ui/UserAuthMenu/UserAuthMenuWidget';
import { SummerMainSection } from '@features/landing/summer/ui/sections/SummerMainSection';
import { PremiumSection } from '@features/landing/shared/ui/sections/PremiumSection';
import { ChessOpenSection } from '@features/landing/shared/ui/sections/ChessOpenSection';
import { SummerAdvantagesSection } from '@features/landing/summer/ui/sections/SummerAdvantagesSection';
import { ActionsSection } from '@features/landing/shared/ui/sections/ActionsSection';
import { Loader } from '@ui/components/Loader';
import { GsapProvider } from '@features/landing/shared/providers/GsapProvider';
import { usePremiumLinksCtx } from '@features/landing/shared/providers/PremiumLinksProvider';
import { ActionsBg } from '@features/landing/shared/ui/components/ActionsBg';
import { SummerTournamentsSection } from '@features/landing/summer/ui/sections/SummerTournamentsSection';
import { SummerAnouncementSection } from '@features/landing/summer/ui/sections/SummerAnouncementSection';

export function SummerLandingPage() {
  const { isLoading } = usePremiumLinksCtx();

  return (
    <GsapProvider>
      <SiteLayout
        rootClassName={styles.root}
        preset="landing"
        siteLogo={<SiteLogoWidget />}
        actions={
          <>
            <UserSettingsMenuWidget />
            <UserAuthMenuWidget />
          </>
        }
      >
        <div className={styles.sections}>
          <SummerMainSection />
          {isLoading ? (
            <div className={styles.loader}>
              <Loader centered />
            </div>
          ) : (
            <>
              <SummerAnouncementSection />
              <SummerTournamentsSection />
              <PremiumSection />
              <ChessOpenSection />
              <SummerAdvantagesSection />
              <ActionsSection />
            </>
          )}
        </div>
        {!isLoading && <ActionsBg />}
      </SiteLayout>
    </GsapProvider>
  );
}
